import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Input from '../../../components/input';
import PhoneNumberInput from '../../../components/PhoneNumberInput';
import Select from '../../../components/Select';
import FileUpload from '../../../components/FileUpload';
import Button from '../../../components/button';
import '../../../styles/Issue.css';
import { useSelector, useDispatch } from 'react-redux';
import { Formik } from 'formik';
import { VendorSchema } from '../../../utils/Schema';
import { createVendor } from '../../../store/Slices/PartVendorSlice';
import { successNotify, errorNotify } from '../../../utils/toast';
import { fetchPartCategoriesDropdown } from '../../../store/Slices/dropdownSlice';

import GoogleMapInput from '../../../components/GoogleMapInput';

const AddVendor = ({ onSave, onCancel }) => {
    const dispatch = useDispatch();

    // Initial values for Formik
    const initialValues = {
        name: '',
        address: {
            vendor_point: '',
            vendor_latitude: '',
            vendor_longitude: ''
        },
        pocName: '',
        pocContact: '',
        pocEmail: '',
        category: [],
        attachments: []
    };

    const { loading, error, partCategoriesDropdownData } = useSelector((state) => state.dropdowns);
    const { createVendorLoading } = useSelector((state) => state.partVendors);
    const [uploadedFiles, setUploadedFiles] = useState([]);

    console.log(partCategoriesDropdownData, "partCategoriesDropdownData");

    useEffect(() => {
        dispatch(fetchPartCategoriesDropdown());
    }, [dispatch]);

    const requiredStar = <span className="required_star">*</span>;

    return (
        <div>
            <Formik
                initialValues={initialValues}
                validationSchema={VendorSchema}
                enableReinitialize={true}
                onSubmit={async (values, { setSubmitting }) => {
                    try {
                        const payload = {
                            name: values.name,
                            location: values.address?.vendor_point,
                            lat: values.address?.vendor_latitude,
                            lng: values.address?.vendor_longitude,
                            poc_name: values.pocName,
                            poc_contact: values.pocContact,
                            poc_email: values.pocEmail,
                            category_ids: Array.isArray(values.category) ? values.category : [values.category],
                            files: uploadedFiles.length > 0 ? uploadedFiles.map(f => f.fileName || f) : (values.attachments || [])
                        };
                        // Note: Using uploadedFiles logic if user intended to use the state `uploadedFiles` 
                        // But originally values.attachments was used. 

                        console.log(payload, "payload");

                        await dispatch(createVendor(payload)).unwrap();
                        successNotify("Vendor created successfully");
                        onSave(values);
                    } catch (err) {
                        errorNotify(err);
                    } finally {
                        setSubmitting(false);
                    }
                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue
                }) => (
                    <form onSubmit={handleSubmit}>
                        <Row>
                            <Col md={12} className="mb-2">
                                <Input
                                    label={<>Vendor Name {requiredStar}</>}
                                    placeholder="Enter Vendor Name"
                                    name="name"
                                    value={values.name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.name}
                                    touched={touched.name}
                                    required={false}
                                />
                            </Col>
                            <Col md={12} className="mb-2">
                                <GoogleMapInput
                                    label={<>Address {requiredStar}</>}
                                    name="address"
                                    value={values.address}
                                    setFieldValue={setFieldValue}
                                    onBlur={handleBlur}
                                    error={errors.address}
                                    touched={touched.address}
                                    fieldPrefix="vendor"
                                    required={false}
                                />
                            </Col>
                            <Col md={12} className="mb-2">
                                <Input
                                    label={<>POC Name {requiredStar}</>}
                                    placeholder="Enter POC Name"
                                    name="pocName"
                                    value={values.pocName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.pocName}
                                    touched={touched.pocName}
                                    required={false}
                                />
                            </Col>
                            <Col md={12} className="mb-2">
                                <Input
                                    label={<>POC Email {requiredStar}</>}
                                    placeholder="Enter POC Email"
                                    name="pocEmail"
                                    value={values.pocEmail}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.pocEmail}
                                    touched={touched.pocEmail}
                                    required={false}
                                />
                            </Col>
                            <Col md={12} className="mb-2">
                                <PhoneNumberInput
                                    label={<>POC Contact {requiredStar}</>}
                                    placeholder="923XXXXXXXXX"
                                    name="pocContact"
                                    value={values.pocContact}
                                    setFieldValue={setFieldValue}
                                    onBlur={handleBlur}
                                    error={errors.pocContact}
                                    touched={touched.pocContact}
                                    required={false}
                                />
                            </Col>
                            <Col md={12} className="mb-2">
                                <Select
                                    label={<>Category {requiredStar}</>}
                                    placeholder="Select Category"
                                    options={partCategoriesDropdownData}
                                    loading={loading}
                                    value={partCategoriesDropdownData?.filter(o => (values.category || []).includes(o.value))}
                                    name="category"
                                    onChange={(opts) => setFieldValue('category', opts ? opts.map(o => o.value) : [])}
                                    onBlur={handleBlur}
                                    error={errors.category || error}
                                    touched={touched.category}
                                    isSearch={false}
                                    isMulti={true}
                                />
                            </Col>

                            <Col md={12}>
                                <div className='issue_file_upload_wrapper'>
                                    <label>Attachments</label>
                                    <FileUpload
                                        destination="service-entry"
                                        files={uploadedFiles}
                                        setFiles={setUploadedFiles}
                                        maxFileSize={10}
                                    />
                                </div>
                            </Col>

                            <Col md={12}>
                                <Button
                                    cancelBtn={onCancel}
                                    submitBtn={handleSubmit}
                                    submitText={createVendorLoading ? "Submitting..." : "Submit"}
                                    type="submit"
                                    loading={createVendorLoading}
                                    disabled={createVendorLoading}
                                />
                            </Col>
                        </Row>
                    </form>
                )}
            </Formik>
        </div>
    );
};

export default AddVendor;
